<template>
  <a-modal
    v-model="showModal"
    :title="isEdit ? 'Edit FAQ' : 'Add FAQ'"
    :footer="null"
    width="600px"
    :destroyOnClose="true"
    class="faq-modal"
  >
    <a-form-model class="" ref="faqForm" :model="form" :rules="rules">
      <a-row class="d-flex">
        <div class="d-flex flex-column" style="width: 100%;">
          <a-form-model-item label="Name" prop="name" :colon="false">
            <a-input
              v-model="form.name"
              placeholder="Name"
              size="large"
              :disabled="loading"
            />
          </a-form-model-item>
          <a-form-model-item label="Description" prop="description" :colon="false">
            <a-input
              v-model="form.description"
              placeholder="Description"
              size="large"
              :disabled="loading"
            />
          </a-form-model-item>
        </div>
      </a-row>
      <a-row class="footer-viewscreen footer">
        <div class="w-fit d-flex justify-content-start">
          <a-popconfirm
            v-if="isEdit"
            placement="top"
            :disabled="loading"
            title="Are you sure you want to delete this FAQ?"
            okText="Delete"
            okType="danger"
            @confirm="deleteFaq"
          >
            <a-button type="danger">
              <a-icon type="delete" theme="filled" />
            </a-button>
          </a-popconfirm>
        </div>
        <div class="d-flex justify-content-end">
          <a-button
            :loading="loading"
            @click="closeModal"
          >
            Cancel
          </a-button>
          <a-button
            type="primary"
            class="ml-2"
            :loading="loading"
            @click="onSubmit"
          >
            {{ isEdit ? 'Save' : 'Create' }}
          </a-button>
        </div>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedFaq: {
      type: Object,
      default: null,
    },
  },
  components: {
  },
  data: () => ({
    showModal: false,
    form: {
      name: '',
      description: '',
    },
    rules: {
      name: [
        {
          required: true,
          message: 'Name is required',
          trigger: ['change'],
        },
      ],
      description: [
        {
          required: true,
          message: 'Description is required',
          trigger: ['change'],
        },
      ],
    },
    imageLoading: false,
    loading: false,
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.showModal = true
        } else {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true,
    },
    showModal: {
      handler(val) {
        if (!val) {
          this.closeModal()
        }
      },
      deep: true,
    },
  },
  computed: {
    isEdit() {
      return !!this.selectedFaq
    },
  },
  methods: {
    templateDataFilling() {
      this.form.name = this.selectedFaq.name
      this.form.description = this.selectedFaq.description
    },
    onSubmit() {
      this.$refs.faqForm.validate(async (valid) => {
        if (valid) {
          if (this.isEdit) {
            this.update()
          } else {
            this.create()
          }
        } else {
          return false
        }
      })
    },
    async create() {
      this.$emit('create', this.form)
      this.closeModal()
    },
    async update() {
      this.$emit('update', { ...this.form, uniqueId: this.selectedFaq.uniqueId })
      this.closeModal()
    },
    async deleteFaq() {
      this.$emit('delete', this.selectedFaq)
      this.closeModal()
    },
    clearForm() {
      this.form = {
        name: '',
        description: '',
      }
    },
    closeModal() {
      this.$emit('close')
      setTimeout(() => {
        this.clearForm()
      }, 500)
    },
  },
  mounted() {
    if (this.selectedFaq) {
      this.templateDataFilling()
    }
  },
}
</script>

<style lang="scss">
.faq-modal {
  .footer {
    display: flex;
    justify-content: space-between;
    &::before,
    &::after {
      content: none;
    }
  }
}
</style>
